import './text-with-solid-bg'
import './text-with-solid-bg.pcss'